import { DesignProvider } from '@platform/ui/config';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@platform/ui/styles.css';
import '@platform/ui/catalog.css';
import '@platform/ui/player.css';
import './room.css';
import './PurchaseSurface.css';
import './live-room.css';
import './draw-summary.css';
import './room-navigation.css';
import './room-inputs.css';
import './room-layout.css';
import './room-mobile.css';
import './room-wide-dialogs.css';
import './room-desktop.css';
const TestSession=import.meta.env.VITE_TEST_ACCOUNTS==='1'?React.lazy(()=>import('@platform/testing/TestSession')):React.Fragment;
const MerchantLaunch=import.meta.env.VITE_MERCHANT_INTEGRATION==='1'?React.lazy(()=>import('@platform/client/MerchantLaunch')):React.Fragment;
const uxPreview=import.meta.env.DEV&&location.pathname==='/ux-preview';
const Screen=uxPreview?React.lazy(()=>import('./UxPreview')):location.pathname==='/guide-preview'?React.lazy(()=>import('./GuidePreview')):location.pathname==='/award-preview'?React.lazy(()=>import('./AwardPreview')):location.pathname==='/broadcast-preview'?React.lazy(()=>import('@platform/broadcast/BroadcastLab')):App;
ReactDOM.createRoot(document.getElementById('root')!).render(<React.StrictMode><DesignProvider theme="tombala"><React.Suspense fallback={null}>{uxPreview?<Screen/>:<MerchantLaunch><TestSession><Screen /></TestSession></MerchantLaunch>}</React.Suspense></DesignProvider></React.StrictMode>);
